import { render, staticRenderFns } from "./ImpressionsIcon.vue?vue&type=template&id=5961181a&"
import script from "./ImpressionsIcon.vue?vue&type=script&lang=js&"
export * from "./ImpressionsIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports